import { defineComponent as _defineComponent } from 'vue'
import { unref, computed } from 'vue';
    import HotelsSearchInput from '@ve/components/filters/searchFilterByHotel/desktop/HotelsSearchInput.vue';
    import { useState } from 'vuex-composition-helpers';
    import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
    import { FoundedHotelFilter } from '@ve/types';
    import SerpTrackingService from '@ve/pages/serp/analytics/yandexAnalytics/serpTrackingService';
    import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
    import useVueProxy from '@ve/services/useVueProxy';

    import TooltipHotelSearch from './ToolTipHotelSearch.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelsSearchWrapper',
  setup(__props) {

    const { $root } = useVueProxy();
    const {
        foundedHotels,
        selectedHotels,
        loadingState,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['foundedHotels', 'selectedHotels', 'loadingState']);
    const serpTrackingService = new SerpTrackingService();
    const getHotel = (hotel: FoundedHotelFilter): { id: number, name: string } => ({
        id: hotel.id,
        name: `${hotel.name}, ${hotel.resortName}`,
    });
    const selectedHotelsAdapt = computed(() => unref(selectedHotels).map((hotel) => getHotel(hotel)));
    const foundedHotelsAdapt = computed(() => unref(foundedHotels).map((hotel) => getHotel(hotel)));
    const onInputHotels = (words: string) => {
        $root?.$emit('input-hotels', words);
        serpTrackingService.filterBySearchHotelInput();
    };
    const onSelectHotel = (hotel: { id: number }) => {
        const selectedHotel = unref(foundedHotels).find(({ id: foundHotelId }) => foundHotelId === hotel.id);
        $root?.$emit('select-hotel', selectedHotel);
    };
    const onDeleteHotel = (hotel: { id: number }) => {
        $root?.$emit('delete-hotel', hotel);
    };
    const onClearHotels = () => {
        $root?.$emit('clear-hotels');
    };
    const onStartSearch = () => {
        $root?.$emit('start-search');
        serpTrackingService.filterBySearchHotelStart();
    };

return { __sfc: true,$root, foundedHotels, selectedHotels, loadingState, serpTrackingService, getHotel, selectedHotelsAdapt, foundedHotelsAdapt, onInputHotels, onSelectHotel, onDeleteHotel, onClearHotels, onStartSearch, HotelsSearchInput, TooltipHotelSearch }
}

})